import { IsArray } from "@pdfking/tfunc"

const cx = (...args: any[]): string => {
  let result = ""
  for (let i = 0; i < args.length; i++) {
    const arg = args[i]
    if (!arg) continue
    if (typeof arg === "string") {
      result += (result ? " " : "") + arg
    } else if (IsArray(arg)) {
      const inner = cx(...arg)
      if (inner) result += (result ? " " : "") + inner
    } else if (typeof arg === "object") {
      for (const key in arg) {
        if (arg[key]) result += (result ? " " : "") + key
      }
    }
  }
  return result
}

export default cx
